export const teamCodes = {
  // Seoul 팀 (지역: 1)
  1211: { team: '연세대 이글스', region: 'Seoul', role: 'coach' },
  1672: { team: '연세대 이글스', region: 'Seoul', role: 'player' },
  1231: { team: '서울대 그린테러스', region: 'Seoul', role: 'coach' },
  1232: { team: '서울대 그린테러스', region: 'Seoul', role: 'player' },
  1971: { team: '한양대 라이온스', region: 'Seoul', role: 'coach' },
  1142: { team: '한양대 라이온스', region: 'Seoul', role: 'player' },
  1741: { team: '국민대 레이저백스', region: 'Seoul', role: 'coach' },
  1092: { team: '국민대 레이저백스', region: 'Seoul', role: 'player' },
  1081: { team: '서울시립대 시티혹스', region: 'Seoul', role: 'coach' },
  1982: { team: '서울시립대 시티혹스', region: 'Seoul', role: 'player' },
  1511: { team: '한국외대 블랙나이츠', region: 'Seoul', role: 'coach' },
  1762: { team: '한국외대 블랙나이츠', region: 'Seoul', role: 'player' },
  1871: { team: '건국대 레이징불스', region: 'Seoul', role: 'coach' },
  1802: { team: '건국대 레이징불스', region: 'Seoul', role: 'player' },
  1371: { team: '홍익대 카우보이스', region: 'Seoul', role: 'coach' },
  1922: { team: '홍익대 카우보이스', region: 'Seoul', role: 'player' },
  1271: { team: '고려대 타이거스', region: 'Seoul', role: 'coach' },
  1785: { team: '고려대 타이거스', region: 'Seoul', role: 'player' },
  1991: { team: '동국대 터스커스', region: 'Seoul', role: 'coach' },
  1131: { team: '동국대 터스커스', region: 'Seoul', role: 'player' },
  1611: { team: '숭실대 크루세이더스', region: 'Seoul', role: 'coach' },
  1782: { team: '숭실대 크루세이더스', region: 'Seoul', role: 'player' },
  1951: { team: '중앙대 블루드래곤스', region: 'Seoul', role: 'coach' },
  1112: { team: '중앙대 블루드래곤스', region: 'Seoul', role: 'player' },
  1071: { team: '경희대 커맨더스', region: 'Seoul', role: 'coach' },
  1752: { team: '경희대 커맨더스', region: 'Seoul', role: 'player' },
  1421: { team: '서강대 알바트로스', region: 'Seoul', role: 'coach' },
  1492: { team: '서강대 알바트로스', region: 'Seoul', role: 'player' },

  // Gyeonggi-Gangwon 팀 (지역: 2)
  2751: { team: '성균관대 로얄스', region: 'Gyeonggi-Gangwon', role: 'coach' },
  2912: { team: '성균관대 로얄스', region: 'Gyeonggi-Gangwon', role: 'player' },
  2011: { team: '강원대 카프라스', region: 'Gyeonggi-Gangwon', role: 'coach' },
  2182: { team: '강원대 카프라스', region: 'Gyeonggi-Gangwon', role: 'player' },
  2119: {
    team: '단국대 코디악베어스',
    region: 'Gyeonggi-Gangwon',
    role: 'coach',
  },
  2662: {
    team: '단국대 코디악베어스',
    region: 'Gyeonggi-Gangwon',
    role: 'player',
  },
  2081: {
    team: '용인대 화이트타이거스',
    region: 'Gyeonggi-Gangwon',
    role: 'coach',
  },
  2742: {
    team: '용인대 화이트타이거스',
    region: 'Gyeonggi-Gangwon',
    role: 'player',
  },
  2871: {
    team: '인하대 틸 드래곤스',
    region: 'Gyeonggi-Gangwon',
    role: 'coach',
  },
  2902: {
    team: '인하대 틸 드래곤스',
    region: 'Gyeonggi-Gangwon',
    role: 'player',
  },
  2111: { team: '한림대 피닉스', region: 'Gyeonggi-Gangwon', role: 'coach' },
  2762: { team: '한림대 피닉스', region: 'Gyeonggi-Gangwon', role: 'player' },
  2521: {
    team: '한신대 킬러웨일스',
    region: 'Gyeonggi-Gangwon',
    role: 'coach',
  },
  2952: {
    team: '한신대 킬러웨일스',
    region: 'Gyeonggi-Gangwon',
    role: 'player',
  },

  // Daegu-Gyeongbuk 팀 (지역: 3)
  3761: {
    team: '경북대 오렌지파이터스',
    region: 'Daegu-Gyeongbuk',
    role: 'coach',
  },
  3092: {
    team: '경북대 오렌지파이터스',
    region: 'Daegu-Gyeongbuk',
    role: 'player',
  },
  3011: { team: '경일대 블랙베어스', region: 'Daegu-Gyeongbuk', role: 'coach' },
  3882: {
    team: '경일대 블랙베어스',
    region: 'Daegu-Gyeongbuk',
    role: 'player',
  },
  3911: {
    team: '계명대 슈퍼라이온스',
    region: 'Daegu-Gyeongbuk',
    role: 'coach',
  },
  3212: {
    team: '계명대 슈퍼라이온스',
    region: 'Daegu-Gyeongbuk',
    role: 'player',
  },
  3331: {
    team: '금오공과대 레이븐스',
    region: 'Daegu-Gyeongbuk',
    role: 'coach',
  },
  3342: {
    team: '금오공과대 레이븐스',
    region: 'Daegu-Gyeongbuk',
    role: 'player',
  },
  3381: {
    team: '대구가톨릭대 스커드엔젤스',
    region: 'Daegu-Gyeongbuk',
    role: 'coach',
  },
  3352: {
    team: '대구가톨릭대 스커드엔젤스',
    region: 'Daegu-Gyeongbuk',
    role: 'player',
  },
  3981: {
    team: '대구대 플라잉타이거스',
    region: 'Daegu-Gyeongbuk',
    role: 'coach',
  },
  3042: {
    team: '대구대 플라잉타이거스',
    region: 'Daegu-Gyeongbuk',
    role: 'player',
  },
  3271: {
    team: '대구한의대 라이노스',
    region: 'Daegu-Gyeongbuk',
    role: 'coach',
  },
  3822: {
    team: '대구한의대 라이노스',
    region: 'Daegu-Gyeongbuk',
    role: 'player',
  },
  3671: {
    team: '동국대 화이트엘리펀츠',
    region: 'Daegu-Gyeongbuk',
    role: 'coach',
  },
  3592: {
    team: '동국대 화이트엘리펀츠',
    region: 'Daegu-Gyeongbuk',
    role: 'player',
  },
  3991: { team: '영남대 페가수스', region: 'Daegu-Gyeongbuk', role: 'coach' },
  3612: { team: '영남대 페가수스', region: 'Daegu-Gyeongbuk', role: 'player' },
  3871: { team: '한동대 홀리램스', region: 'Daegu-Gyeongbuk', role: 'coach' },
  3522: { team: '한동대 홀리램스', region: 'Daegu-Gyeongbuk', role: 'player' },

  // Busan-Gyeongnam 팀 (지역: 4)
  4711: { team: '경성대 드래곤스', region: 'Busan-Gyeongnam', role: 'coach' },
  4972: { team: '경성대 드래곤스', region: 'Busan-Gyeongnam', role: 'player' },
  4891: { team: '동서대 블루돌핀스', region: 'Busan-Gyeongnam', role: 'coach' },
  4542: {
    team: '동서대 블루돌핀스',
    region: 'Busan-Gyeongnam',
    role: 'player',
  },
  4041: { team: '동아대 레오파즈', region: 'Busan-Gyeongnam', role: 'coach' },
  4482: { team: '동아대 레오파즈', region: 'Busan-Gyeongnam', role: 'player' },
  4121: {
    team: '동의대 터틀파이터스',
    region: 'Busan-Gyeongnam',
    role: 'coach',
  },
  4782: {
    team: '동의대 터틀파이터스',
    region: 'Busan-Gyeongnam',
    role: 'player',
  },
  4781: { team: '부산대 이글스', region: 'Busan-Gyeongnam', role: 'coach' },
  4222: { team: '부산대 이글스', region: 'Busan-Gyeongnam', role: 'player' },
  4221: {
    team: '부산외국어대 토네이도',
    region: 'Busan-Gyeongnam',
    role: 'coach',
  },
  4672: {
    team: '부산외국어대 토네이도',
    region: 'Busan-Gyeongnam',
    role: 'player',
  },
  4761: { team: '신라대 데빌스', region: 'Busan-Gyeongnam', role: 'coach' },
  4992: { team: '신라대 데빌스', region: 'Busan-Gyeongnam', role: 'player' },
  4621: { team: '울산대 유니콘스', region: 'Busan-Gyeongnam', role: 'coach' },
  4822: { team: '울산대 유니콘스', region: 'Busan-Gyeongnam', role: 'player' },
  4811: {
    team: '한국해양대 바이킹스',
    region: 'Busan-Gyeongnam',
    role: 'coach',
  },
  4052: {
    team: '한국해양대 바이킹스',
    region: 'Busan-Gyeongnam',
    role: 'player',
  },

  // Amateur 팀 (지역: 5)
  5761: { team: '군위 피닉스', region: 'Amateur', role: 'coach' },
  5552: { team: '군위 피닉스', region: 'Amateur', role: 'player' },
  5111: { team: '부산 그리폰즈', region: 'Amateur', role: 'coach' },
  5982: { team: '부산 그리폰즈', region: 'Amateur', role: 'player' },
  5731: { team: '삼성 블루스톰', region: 'Amateur', role: 'coach' },
  5432: { team: '삼성 블루스톰', region: 'Amateur', role: 'player' },
  5781: { team: '서울 골든이글스', region: 'Amateur', role: 'coach' },
  5872: { team: '서울 골든이글스', region: 'Amateur', role: 'player' },
  5991: { team: '서울 디펜더스', region: 'Amateur', role: 'coach' },
  5522: { team: '서울 디펜더스', region: 'Amateur', role: 'player' },
  5171: { team: '서울 바이킹스', region: 'Amateur', role: 'coach' },
  5662: { team: '서울 바이킹스', region: 'Amateur', role: 'player' },
  5871: { team: '인천 라이노스', region: 'Amateur', role: 'coach' },
  5422: { team: '인천 라이노스', region: 'Amateur', role: 'player' },

  2025: { team: 'ADMIN', region: 'ALL', role: 'admin' },
};
